import { render, staticRenderFns } from "./arbitrage-order-inquiry.vue?vue&type=template&id=274d3c60&scoped=true&"
import script from "./arbitrage-order-inquiry.vue?vue&type=script&lang=js&"
export * from "./arbitrage-order-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./arbitrage-order-inquiry.vue?vue&type=style&index=0&id=274d3c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274d3c60",
  null
  
)

export default component.exports